import { useTimezoneParam } from '@features/date-time';
import { useFilter } from '@features/table-filter';

import { useGetTraderWalletsQuery } from '../api';
import type { ITraderWalletFilter } from '../model/types';

interface IProps {
  disableUrlFilter?: boolean;
}

export const useTraderWallets = ({ disableUrlFilter }: IProps = {}) => {
  const filter = useFilter<ITraderWalletFilter>({ disableUrlFilter });
  const { currentFilter, updateFilter } = filter;

  useTimezoneParam({ currentFilter, updateFilter });

  const {
    data: traderWallets,
    isLoading,
    isError,
    error,
    isFetching,
    isSuccess,
    refetch,
  } = useGetTraderWalletsQuery(currentFilter.toString());

  return {
    traderWallets,
    isError,
    error,
    isLoading,
    isFetching,
    isSuccess,
    refetch,

    filter,
  };
};
